import {observer} from "mobx-react-lite";
import React from "react";
import {useTranslation} from "react-i18next";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {IconSource} from "../../../shared/enums/iconSource";
import ResidentModalDetail from "../../../stores/domainStore/pages/models/residentModalDetail";
import ButtonIcon from "../../atoms/button/buttonIcon";
import NavigationButton from "../../atoms/button/navigationButton";
import "./removeAccountConfirmModal.sass";

export interface IRemoveAccountConfirmModalProps {
  resident?: ResidentModalDetail;
  isLoading: boolean;
  isOpen: boolean;
  clearSelectedResident?: () => void;
  removeAccountConfirm?: () => void;
}

const RemoveAccountConfirmModal: React.FC<IRemoveAccountConfirmModalProps> = ({
  resident,
  isLoading,
  isOpen,
  removeAccountConfirm,
  clearSelectedResident
}) => {
  const {t} = useTranslation(["translation", "residentadmin"]);

  const formatHeaderText = (): string => {
    return (
      t("residentadmin:labels.removeAccountConfirmationHeaderPrefix") +
      resident?.formattedResidentName
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      modalClassName="theme-modal resident-remove-confirm-modal"
      contentClassName="border"
      centered
    >
      <ModalHeader
        close={
          <NavigationButton
            icon={IconSource.exit}
            onClick={clearSelectedResident}
          />
        }
      >
        {formatHeaderText()}
      </ModalHeader>
      <ModalBody>
        {t("residentadmin:labels.removeAccountConfirmationInfo")}
      </ModalBody>
      <ModalFooter className="border-0 bg-light">
        <ButtonIcon
          type="primary-negative"
          onClick={removeAccountConfirm}
          isBusy={isLoading}
        >
          {t("residentadmin:buttons.removeAccountConfirmation")}
        </ButtonIcon>
      </ModalFooter>
    </Modal>
  );
};

export default observer(RemoveAccountConfirmModal);
